export default __webpack_public_path__ + "1296c514bb63b55f4b9b586a2ee8a497.svg";